/**
 * Step2 表格表头 / 内联表单标签：必填项红色 * 标记。
 */
import React from 'react';
import classNames from 'classnames';
import { Text } from 'tea-component';

interface IFieldConfigRequiredLabelProps {
  children: React.ReactNode;
  required?: boolean;
  /** 表头用 span；内联表单用 label 样式 */
  variant?: 'header' | 'inline';
}

export const FieldConfigRequiredLabel: React.FC<IFieldConfigRequiredLabelProps> =
  ({
    children, required = false,
    variant = 'header'
  }) => {
    if (variant === 'inline') {
      return (
        <Text
          className={classNames('dbl-field-config-inline-add__label', {
            'dbl-field-config-required-mark': required,
          })}
        >
          {children}
        </Text>
      );
    }
    return (
      <span
        className={classNames('dbl-field-config-col-header', {
          'dbl-field-config-required-mark': required,
        })}
      >
        {children}
      </span>
    );
  };
